// Mock data for Urban Outsourcing clone

export const siteConfig = {
  brand: {
    mark: 'uo',
    name: 'URBANOUTSOURCING',
  },
  nav: [
    { label: 'HOME', to: '/' },
    { label: 'WHAT WE DO', to: '/what-we-do' },
    { label: 'CLIENT PARTNERS', to: '/client-partners' },
  ],
  cta: { label: 'CONTACT', to: '/contact' },
};

export const homeContent = {
  heroImage:
    'https://images.squarespace-cdn.com/content/v1/54504c8be4b009c6e858d517/1414591691534-77732BKDHIHOB1V89OI7/south+jamaica+houses.jpg',
  heroQuote:
    '\u201CAll labor that uplifts humanity has dignity and importance and should be undertaken with painstaking excellence.\u201D',
  heroAttribution: 'Martin Luther King, Jr.',

  intro: {
    eyebrow: 'MANAGEMENT CONSULTING',
    heading: 'Business-class expertise. Community-rooted impact.',
    lead:
      'Urban Outsourcing is a for-profit social venture delivering management consulting in Data Science, Analytics, System Design, Development and Operational Excellence \u2014 with a mission to open a path to participation for talent from underserved communities.',
  },

  pillarsPreview: {
    eyebrow: 'WHAT WE DO',
    heading: 'Five practices. One collaborative model.',
    description:
      'We partner with our clients to enable the business and technology-critical capabilities that move their organizations forward.',
  },

  approach: {
    eyebrow: 'OUR APPROACH',
    heading: 'Collaboration is the method. Capability is the outcome.',
    description:
      'We do not parachute in and disappear. We work alongside your teams to co-design solutions, transfer knowledge and leave lasting capability behind.',
    steps: [
      {
        n: '01',
        title: 'Assess',
        body:
          'We begin by listening. Structured discovery aligns stakeholders around the real problem, the desired outcome and the constraints that matter.',
      },
      {
        n: '02',
        title: 'Co-design',
        body:
          'Solutions are shaped together with your team. Architecture, data models and delivery plans are drafted openly, not handed down.',
      },
      {
        n: '03',
        title: 'Build',
        body:
          'Our practitioners deliver alongside your staff. Every engagement pairs senior consultants with emerging talent from our Path to Participation program.',
      },
      {
        n: '04',
        title: 'Enable',
        body:
          'We invest in your people. Runbooks, playbooks and pairing sessions turn a delivered system into an owned capability.',
      },
      {
        n: '05',
        title: 'Transition',
        body:
          'A clean handoff is the goal from day one. When we leave, your team is confident, credentialed and equipped to operate and evolve what we built together.',
      },
    ],
  },

  impact: {
    eyebrow: 'THE PATH TO PARTICIPATION',
    heading: 'Skilled trades for a knowledge economy.',
    body:
      'Every engagement funds and staffs our Path to Participation program \u2014 a pipeline that recruits, trains and mentors technologists from urban centers that have been historically overlooked by the industry. When you engage Urban Outsourcing, you invest in results and in a wider circle of opportunity.',
    stats: [
      { value: 'Onsite', label: 'Onshore & Offshore delivery models' },
      { value: 'Senior', label: 'Consultants leading every engagement' },
      { value: 'Path', label: 'To participation on every project' },
    ],
  },
};

export const whatWeDoContent = {
  heroImage:
    'https://images.squarespace-cdn.com/content/v1/54504c8be4b009c6e858d517/1414618179599-2CVS1LADMJ0LGTZW051M/_DSC5393.jpg',
  heroQuote: 'Compassionate Computing',

  intro: {
    eyebrow: 'PRACTICES',
    heading: 'Five practices, delivered collaboratively.',
    lead:
      'Our services are structured as five interlocking practices. Each is led by senior consultants, supported by rigorously vetted practitioners, and shaped around your team\u2019s reality \u2014 not a boilerplate playbook.',
  },

  pillars: [
    {
      key: 'data-science',
      icon: 'LineChart',
      title: 'Data Science & Analytics',
      body:
        'We turn data into decisions. Our data scientists build the models, pipelines and reporting layers that surface actionable insight \u2014 from exploratory analysis through production ML and executive dashboards.',
      capabilities: [
        'Statistical modeling & forecasting',
        'Machine learning engineering',
        'Data warehousing & ETL',
        'Executive BI & self-service reporting',
      ],
    },
    {
      key: 'system-design',
      icon: 'Blocks',
      title: 'System Design & Architecture',
      body:
        'Sound architecture is the difference between a system that scales and one that stalls. We design for resilience, extensibility and total cost of ownership across cloud, hybrid and on-premise environments.',
      capabilities: [
        'Solution & enterprise architecture',
        'Cloud migration & modernization',
        'Data architecture & governance',
        'Integration & API strategy',
      ],
    },
    {
      key: 'development',
      icon: 'Code2',
      title: 'Development & Maintenance',
      body:
        'From greenfield builds to steady-state maintenance, our engineers deliver production software that meets the specification, the deadline and the budget \u2014 with the documentation your team needs to operate it.',
      capabilities: [
        'Web, desktop & mobile application development',
        'Database engineering',
        'Legacy platform support & modernization',
        'DevOps, CI/CD and release engineering',
      ],
    },
    {
      key: 'operational-excellence',
      icon: 'Workflow',
      title: 'Operational Excellence',
      body:
        'We help operations teams do more with less. Process reengineering, automation and measurement frameworks turn day-to-day work into a steadily improving system.',
      capabilities: [
        'Process reengineering & automation',
        'KPI design & performance measurement',
        'Service management & runbook development',
        'Continuous improvement programs',
      ],
    },
    {
      key: 'management-consulting',
      icon: 'Compass',
      title: 'Management Consulting',
      body:
        'Strategy is only useful if it can be executed. Our advisors work at the intersection of business and technology to sharpen priorities, structure programs and equip leaders to deliver.',
      capabilities: [
        'Technology strategy & roadmapping',
        'Program & portfolio management',
        'Vendor & sourcing advisory',
        'Organizational design for delivery',
      ],
    },
  ],
};

export const clientPartnersContent = {
  heroImage:
    'https://images.squarespace-cdn.com/content/v1/54504c8be4b009c6e858d517/1414618179599-2CVS1LADMJ0LGTZW051M/_DSC5393.jpg',
  heroQuote: 'Partners in Progress',
  heading: 'Client Partners',
  intro:
    'We are proud to collaborate with organizations that share our commitment to leveraging technology as a force for economic mobility and social good. Our client partners span industries, geographies and missions \u2014 united by a belief that excellent work uplifts communities.',
  industries: [
    'Financial Services',
    'Pharmaceutical',
    'Publishing',
    'Manufacturing',
    'Non\u2010Profit',
    'Higher Education',
  ],
  closing:
    'To learn more about our engagement models or to explore a partnership, please reach out through our contact page. We welcome the opportunity to introduce our team and discuss how Urban Outsourcing can support your mission\u2010critical objectives.',
};

export const contactContent = {
  heroImage:
    'https://images.squarespace-cdn.com/content/v1/54504c8be4b009c6e858d517/1414618243023-UIQQM45X3WK5Q7PBCI77/_DSC5666.jpg',
  heroQuote: 'Contact',
  address: {
    line1: '335 Peters St SW',
    line2: 'Atlanta, Georgia, 30313',
  },
  phone: '(908) 963-6893',
  email: 'consult@urbanoutsource.com',
  mapEmbed:
    'https://www.google.com/maps?q=335+Peters+St+SW,+Atlanta,+Georgia,+30313&hl=en&z=15&output=embed',
};
